import { GuideItemConfig, GuideItemType } from '../constants/guide-items';

export function getItemCompleted(
  config: GuideItemConfig,
  completionMap: Map<string, boolean>
): boolean {
  if (config.type === GuideItemType.COMPOSITE && config.subItems) {
    return config.subItems.every(sub => completionMap.get(sub.key) ?? false);
  }
  return completionMap.get(config.key) ?? false;
}
